import { apiUrl, getList, download } from './apiUtils';
import type { ApiListParamsWithUnderscores } from '../types/api/listParams';
import type { ListApiResponse } from '../types/apiResponse';
import type { HealthCheckModel } from '../types/api/healthCheck';

const baseUrl = apiUrl + '/healthcheck/';

export function getHealthChecks(
  params?: ApiListParamsWithUnderscores
): Promise<ListApiResponse<HealthCheckModel>> {
  return getList<HealthCheckModel>(`${baseUrl}search`, params);
}

export function downloadHealthCheck(id: string): Promise<void> {
  return download(`${baseUrl}${id}/download`);
}
